<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal-lg modal-dialog-centered w-100" :class="modalClass">
                <div class="modal-content shadow">
                    <div class="modal-header border-0 p-4 pb-2">
                        <span class="col-sm-8 d-flex align-middle">
                            <svg class="icon"><use href="@/assets/images/icons/cog.svg#icon"></use></svg>
                            {{ !this.isNewSpace ? $t("UI.changeCompany") : $t("UI.addCompany") }}
                        </span>
                        <div class="d-flex justify-content-end flex-grow-1">
                            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                            </button>
                        </div>
                    </div>

                    <div class="modal-body ps-3 pe-3">
                        <div class="row m-0 w-100 h-100" v-if="spaceData">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="np-font-m np-f-medium mb-2" for="spaceName">{{ $t("UI.name") }}</label>
                                    <input type="text" class="form-control np-input" id="spaceName" aria-describedby="spaceNameHelp"
                                        v-model="spaceData.title">
                                    <small id="spaceNameHelp" class="form-text text-muted"></small>
                                </div>
                                <div class="mb-4">
                                    <label class="np-font-m np-f-medium mb-2" for="companyDescription">{{ $t("UI.description") }}</label>
                                    <textarea class="form-control np-textarea" id="companyDescription"
                                        v-model="spaceData.description">
                                    </textarea>
                                </div>                                                                                              
                            </div>
                        </div>                            
                    </div>

                    <div class="modal-footer p-3">
                        <button type="button" class="np-btn np-danger px-4 me-1"
                            data-bs-dismiss="modal" :disabled="isLoading">{{ $t("UI.close") }}</button>
                        <button type="button" class="np-btn np-success-filled px-4" @click="updateSpace()" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ $t("UI.save") }}
                        </button>
                    </div>                    
                </div>
        </div>
    </div>
</template>

<script>
import { useDashboardStore } from "@/stores/dashboardStore"
import { Modal } from "bootstrap"

export default {
    components: {
    },
    props: {
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        }          
    }, 
    data() {
        return {  
            emptySpace: {
                id: 0,
                title: '',
                description: ''
            },
            spaceData: {},
            isNewSpace: false,           
            theModal: null,
            theModalLabel: null,
            isLoading: false
        }
    },    
    computed: {   
        dashboardStore() {
            return useDashboardStore()
        }          
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },           
    methods: {
        async shows(spaceData) {
            if (!spaceData) {
                this.spaceData = Object.assign({}, this.emptySpace)
                this.isNewSpace = true
            } else {
                this.spaceData = Object.assign({}, spaceData)
                this.isNewSpace = false
            }

            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal')
        },
        async updateSpace() {
            this.isLoading = true

            await this.dashboardStore.updateSpace(this.spaceData)

            this.isLoading = false
            this.$emit('refresh')
            this.hide()
        }, 
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>